export default __webpack_public_path__ + "static/media/win.59e8d9d5.mp3";